export default "__VITE_ASSET__xRj9FyCQ__"